"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Switch;

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _SwitchBase = _interopRequireDefault(require("./SwitchBase"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

if (process.env.SCALE_MEDIUM && process.env.SCALE_LARGE) {
  require("../../spectrum-css-overrides/toggle/index.css");

  require("../../spectrum-css-overrides/toggle/index-diff.css");
} else if (process.env.SCALE_LARGE) {
  require("../../spectrum-css-overrides/toggle/index-lg.css");
} else {
  require("../../spectrum-css-overrides/toggle/index.css");
}

if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHT) require("../../spectrum-css-overrides/toggle/multiStops/light.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARK) require("../../spectrum-css-overrides/toggle/multiStops/dark.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHTEST) require("../../spectrum-css-overrides/toggle/multiStops/lightest.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARKEST) require("../../spectrum-css-overrides/toggle/multiStops/darkest.css");

function Switch(_ref) {
  var _classNames;

  var variant = _ref.variant,
      quiet = _ref.quiet,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, ["variant", "quiet", "className"]);

  return _react["default"].createElement(_SwitchBase["default"], _extends({
    inputType: "checkbox",
    className: (0, _classnames["default"])('spectrum-ToggleSwitch', (_classNames = {}, _defineProperty(_classNames, "spectrum-ToggleSwitch--".concat(variant), variant), _defineProperty(_classNames, 'spectrum-ToggleSwitch--quiet', quiet), _classNames), className),
    inputClassName: "spectrum-ToggleSwitch-input",
    markClassName: "spectrum-ToggleSwitch-switch",
    labelClassName: "spectrum-ToggleSwitch-label",
    role: "switch"
  }, otherProps));
}

Switch.displayName = 'Switch';
Switch.propTypes = {
  /**
  * Class given to switch
  */
  className: _propTypes["default"].string,

  /**
  * Whether the switch is checked or not (controlled state)
  */
  checked: _propTypes["default"].bool,

  /**
  * Whether the switch should be checked (uncontrolled state)
  */
  defaultChecked: _propTypes["default"].bool,

  /** Text to add to switch. Can be Text of HTML */
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),

  /**
  * Function called when switch is changed
  */
  onChange: _propTypes["default"].func,

  /**
  * Whether switch is a quiet variation
  */
  quiet: _propTypes["default"].bool,

  /**
  * Change switch to A/B variant rather an on/off
  */
  variant: _propTypes["default"].oneOf(['ab'])
};